import CompanyDetailsData from './CompanyDetailsData';

export default CompanyDetailsData;
